import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.css']
})
export class DatePickerComponent implements OnInit, OnDestroy {
  @Input() fieldDetails: any;
  @Output() formGenerated = new EventEmitter<any>();
  maxDate: any = new Date();
  userSubmit: boolean = false;
  form = new UntypedFormGroup({});

  private _subscription: Subscription;

  constructor(private _dataSer: DataService) {
    this._subscription = this._dataSer.events.subscribe((res: any) => {
      if (res.name === 'reportSubmit') {
        this._onSubmit()
      }
    });
  }

  ngOnInit(): void {
  }
  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }
  ngOnChanges(): any {
    this.form = new UntypedFormGroup({});
    this.form.addControl(
      this.fieldDetails?.id,
      new UntypedFormControl('', this.fieldDetails?.required ? Validators.required : null)
    );
  }

  get formValues() {
    return this.form.controls;
  }

  private _onSubmit(actionType: string = 'submit') {
    if (actionType === 'submit') {
      this.userSubmit = true;
      if (this.form.valid) {
        if (this.fieldDetails?.start) {
          this.form.value.startTime = new Date(this.form.value.startTime.setHours('00', '00'));
        }
        if (this.fieldDetails?.end) {
          this.form.value.endTime = new Date(this.form.value.endTime.setHours('23', '59'));
        }
        this.formGenerated.emit(this.form.value);
      }
    }
    // else if (actionType === 'clear') {
    //   this.form.reset();
    //   this.formGenerated.emit({ formValue: this.form.value });
    // } else {
    //   this.formGenerated.emit({ formValue: null });
    // }
  }
}
